export default __webpack_public_path__ + "static/media/Orc.2270273d.jpg";